var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAladin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 512 512",
    fill: "none",
    stroke: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ellipse-mask"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 256,
    rx: 250,
    ry: 150,
    transform: "rotate(-20, 256, 256)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 256,
    rx: 230,
    ry: 144,
    transform: "rotate(-20, 256, 256)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 256,
    rx: 200,
    ry: 110,
    transform: "rotate(-20, 256, 256)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 256,
    rx: 180,
    ry: 104,
    transform: "rotate(-20, 256, 256)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 256,
    rx: 150,
    ry: 70,
    transform: "rotate(-20, 256, 256)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 256,
    rx: 130,
    ry: 64,
    transform: "rotate(-20, 256, 256)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 196 L 511 196 L 511 316 L 1 316 L 1 196 Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 511 1 L 511 511 L 1 511 L 1 1 Z",
    fill: "currentColor",
    mask: "url(#ellipse-mask)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 46 248 L 28 301 L 111 302 L 83 212 L 60 212 L 83 283 L 56 283 L 65 248 L 46 248 Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 118 212 L 118 301 L 169 301 L 173 283 L 140 283 L 140 212 L 118 212 Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 190 248 L 172 301 L 255 302 L 227 212 L 204 212 L 227 283 L 200 283 L 209 248 L 190 248 Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 263 248 L 263 301 L 293 301 A 46 46 180 0 0 293 209 L 263 212 L 263 231 L 293 231 A 25 25 180 0 1 293 281 L 285 281 L 285 248 L 263 248 Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 351 212 L 372 212 L 372 231 L 351 231 L 351 212 Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 351 249 L 372 249 L 372 302 L 351 302 L 351 249 Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 387 212 L 387 302 L 410 302 L 409 231 L 427 231 A 10 10 45 0 0 437 241 L 434 302 L 457 302 L 456 235 A 25 25 45 0 1 433 212 L 387 212 Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAladin);
export default __webpack_public_path__ + "static/media/aladin.56c8f9af0cd77a2e7787c7eceddd340f.svg";
export { ForwardRef as ReactComponent };